import {performRequest} from "@/api";

const MAIN_API_URL = 'https://api.cashbackalert.net/api/';
const chromeExtensionLink = 'https://chrome.google.com/webstore/detail/cashback-alert/jjplgdahehldgdmahmiknpoeecbeadll';
const edgeExtensionLink = 'https://microsoftedge.microsoft.com/addons/detail/cashback-alert/jcmpcfpkpigcghokafkgnlnppggbbmla';
const mobileAppLink = 'https://play.google.com/store/apps/details?id=com.buntai.cashbackalert';

function inIframe () {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
}

function fetchStores (setting, firstRequest) {
  const url = new URL(MAIN_API_URL+'get_store')
  Object.keys(setting).forEach(key => {
    if(setting[key]){
      url.searchParams.append(key, setting[key])
    }
  })
  /*firstRequest = this.isFirstRequest, page = this.pagination.page++, category = this.activeSubCategory || false, sorting = false*/
  this.loader = !!firstRequest
  this.moreStoresLoader = !firstRequest
  performRequest(
    url,
    {
      method: 'POST',
    }
  ).then(res => {
    console.log(res);
    res.data.stores.forEach((item) => {
      let computedLogo = '';
      if (item.raw_logo_api) {
        try {
          const logoJson = JSON.parse(item.raw_logo_api.toString())
          computedLogo = (logoJson.logo && logoJson.logo.image) || (logoJson.icon && logoJson.icon.image) || item.image || item.icon;
        } catch (error) {
          computedLogo = item.image || item.icon;
        }
      } else {
        computedLogo = item.image || item.icon;
      }
      item.computedLogo = computedLogo;

    })
    this.stores = this.stores ? this.stores.concat(res.data.stores) : res.data.stores
    console.log(this.stores);
    this.loader = false
    this.moreStoresLoader = false
  }).catch((error) => {
    console.error('Error:', error);
  })
}

function reportEvent(eventName, propertyName) {
  if (process.env.NODE_ENV === 'development') {
    console.log(eventName, propertyName);
    return true;
  }
  const labelData = {};
  const labelDataArr = [];
  if (propertyName) {
    labelData["propertyName"] = propertyName;
  }
  console.log(inIframe());
  labelData["source"] = inIframe() ? 'extension' : 'site';
  labelDataArr.push(labelData);

  const formData = new FormData()
  formData.append('a', eventName);
  formData.append('l', JSON.stringify(labelDataArr));
  return fetch('/r/', {
    method: 'POST',
    cache: 'no-cache',
    credentials: 'same-origin',
    body: formData
  });
}

export {MAIN_API_URL, chromeExtensionLink, edgeExtensionLink, mobileAppLink, fetchStores, reportEvent}
